var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full",attrs:{"id":"dictionaryManagement"}},[_c('el-row',{staticClass:"h-full",attrs:{"gutter":10}},[_c('el-col',{staticClass:"h-full",attrs:{"span":12}},[_c('dicType',{on:{"search":_vm.search,"clear":_vm.clear}})],1),_c('el-col',{staticClass:"h-full",attrs:{"span":12}},[_c('dicItem',{ref:"dicItem"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }